import { create } from 'zustand';

export const useChatStore = create((set, get) => ({
  // State
  chats: [],
  currentChatId: null,
  chatMessages: {}, // Speichert Nachrichten nach Chat-ID
  searchTerm: '',
  
  // Chat-Liste
  setChats: (chats) => set({ chats }),
  
  // Aktuellen Chat setzen
  setCurrentChatId: (chatId) => set({ currentChatId: chatId }),
  
  // Suchfunktionalität
  setSearchTerm: (term) => set({ searchTerm: term }),
  
  // Chat-Nachrichten verwalten
  setChatMessages: (chatId, messages) => set((state) => ({
    chatMessages: {
      ...state.chatMessages,
      [chatId]: messages
    }
  })),
  
  // Eine Nachricht zu einem Chat hinzufügen
  addChatMessage: (chatId, message) => set((state) => {
    const currentMessages = state.chatMessages[chatId] || [];
    return {
      chatMessages: {
        ...state.chatMessages,
        [chatId]: [...currentMessages, message]
      }
    };
  }),
  
  // Computed Getter: liefert nach Suchbegriff gefilterte Chats
  filteredChats: () => {
    const { chats, searchTerm } = get();
    if (!searchTerm) return chats;
    return chats.filter((chat) =>
      chat.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  },
}));